import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  isLoading: false,
  blogs: [],
  error: "",
}

const BlogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isLoading = true
    },
    getBlogsSuccess: (state, { payload }) => {
      state.isLoading = false
      state.blogs = payload
      state.error = ""
    },
    getBlogsFail: (state, { payload }) => {
      state.isLoading = false
      state.error = payload
    },
  },
})

const { reducer, actions } = BlogSlice
export const { isPending, getBlogsSuccess, getBlogsFail } = actions

export default reducer
